<template>
    <b-container fluid class="mt-4">
        <p><router-link to="/interaction-studio">Back to Guide List</router-link></p>
        <h2>FarmD Interaction Studio Guides: {{guideDisplayName}}</h2>
        <component :is="guideContent" />
    </b-container>
</template>

<script>
    import InteractionStudio from './InteractionStudio';
    import StateMachineEditor from './StateMachineEditor';
    import AnimationEditor from './AnimationEditor';
    
export default {
    name: 'StudioGuides',
    computed: {
        guideContent() {
            var guides = {
                "InteractionStudio": InteractionStudio,
                "StateMachineEditor": StateMachineEditor,
                "AnimationEditor": AnimationEditor,
            }

            return guides[this.$route.params.guideName];
        },
        guideDisplayName() {
            return this.$route.params.guideName.replace(/([A-Z])/g, ' $1').trim();
        }
    }
}
</script>

<style>
    .guide-list {
        margin-right: auto;
        font-size: 1em;
    }

    .guide-list .btn {
        font-size: 1em;
        padding: 0px;
        padding-bottom: 0.15em;
    }

    .guide-list img {
        max-height: 500px;
        margin-bottom: 1em;
    }

    .guide-list h4 {
        border: 2px solid gray;
        border-radius: 5px;
        padding: 1rem;
        margin-top: 5rem;
        margin-bottom: 2rem;
    }

    body {
        margin-bottom: 100px
    }

    .table-of-contents .active {
        font-weight: bold;
    }
</style>
